import React from "react";

const useBuilderData = () => {
  let [builderData, setBuilderData] = React.useState({
    project: {
      text: "",
      id: null,
      type: null,
      children: null,
    },
    sideBar: {},
  });
  return { builderData, setBuilderData };
};
export default useBuilderData;
